var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer__version"},[_c('div',{staticClass:"footer__version-custom"},[_c('span',[_vm._v("Versão "+_vm._s(_vm.getVersion()))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }